import { render, staticRenderFns } from "./CategoryProductsSlider.vue?vue&type=template&id=d813aab6&scoped=true&"
import script from "./CategoryProductsSlider.vue?vue&type=script&lang=js&"
export * from "./CategoryProductsSlider.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProductsSlider.vue?vue&type=style&index=0&id=d813aab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d813aab6",
  null
  
)

export default component.exports